import React from "react";
import PropTypes from "prop-types";

const Item = ({ data }) => (
  <tr>
    <td className="table-bucket">{data.name}</td>
    <td className="table-cell-red table-bucket">
      {data.counts[0]} Employees ({data.percents[0]}%)
    </td>
    <td className="table-cell-yellow table-bucket">
      {data.counts[1]} Employees ({data.percents[1]}%)
    </td>
    <td className="table-cell-green table-bucket">
      {data.counts[2]} Employees ({data.percents[2]}%)
    </td>
  </tr>
);

const Graph = ({ data }) => (
  <span>
    <table className="table table-clean table-white">
      <thead>
        <tr>
          <th width="25%" className="text-center word-break">
            Certifications
          </th>
          <th width="25%" className="text-center">
            Expired
          </th>
          <th width="25%" className="text-center">
            Expiring in 0-90 Days
          </th>
          <th width="25%" className="text-center">
            Expiring in 90+ Days
          </th>
        </tr>
      </thead>

      <tbody>
        {data.map((item, index) => (
          <Item key={index} data={item} />
        ))}
      </tbody>
    </table>
    <p className="grey-text">
      Only active employees are included in certifications analytics
    </p>
  </span>
);

Graph.propTypes = {
  data: PropTypes.array.isRequired
};

export default Graph;
